export default "__VITE_ASSET__CwenUnBV__"